import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { MutualFundsTaskTable } from '../../../../../../../../../../features/mutual-funds/task/mutual-funds-task-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/task/_task/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsMutualfunds,
      label: 'Tasks',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsMutualfunds>,
  head: () => getPageHead('Mutual Funds Tasks'),
  component: MutualFundsTasksList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsMutualfunds}
    />
  );
}

function MutualFundsTasksList() {
  return (
    <PageLayout>
      <PageLayout.Section>
        <MutualFundsTaskTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
